export default __webpack_public_path__ + "static/media/Mathematics.643ea49a.pdf";